<template>
  <div class="flex flex-col ">
    <div v-if="loading" class="wrapper-loading">
      <aha-spinner />
      {{ $i18nPresenter.t('Crafting some questions for you') }}...
    </div>
    <div v-if="isShowRecommendation" class="wrapper">
      <div
        v-for="(suggestion, index) in recommendations"
        :key="index"
        @click="applyQuestion(suggestion)"
        class="flex-grow text-sm cursor-pointer center-box "
      >
        <!-- TODO:  Replace this custom ButtonLink component with the official one from Ant Design -->
        <!--once it becomes available in the updated version of the library.    -->
        <ButtonLink
          v-aha-emit-action
          name="question_suggestion"
        >
          <span class="box-svg">
            <aha-icon name="idea_suggestion" />
          </span>
          <span class="truncate" :title="suggestion">{{ suggestion }}</span>
        </ButtonLink>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import ButtonLink from '@/components/UI/ButtonLink.vue'
import OpenAIApi from '@/api/openai'
import { ALLOWED_OBJECT_TYPE, ALLOWED_ACTION_TYPE } from '@/constant/aiAction'

const TITLE_ID_NAME = 'title-slide-edit'
export default {
  name: 'SlideQuestionSuggestions',
  components: {
    ButtonLink,
  },
  data() {
    return {
      recommendations: [],
      loading: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isQuizSlideType', 'isSlideTitleEmpty']),

    isShowRecommendation() {
      return this.recommendations && this.recommendations.length > 0 &&
          this.isSlideTitleEmpty && this.isQuizSlideType
    },
  },
  async mounted() {
    if (this.slideActive && this.isQuizSlideType && this.isSlideTitleEmpty) {
      this.loading = true

      this.recommendations = await this.fetchQuestionRecommendations()
      this.loading = false
    }
  },
  destroyed() {
    this.recommendations = []
  },
  methods: {
    ...mapActions('questionRecommendations', ['fetchQuestionRecommendations']),
    applyQuestion(question) {
      const titleDom = document.getElementById(TITLE_ID_NAME)
      if (titleDom) {
        titleDom.value = question
        // visual event change input
        const event = new Event('input', { bubbles: true })
        titleDom.dispatchEvent(event)
        this.trackAIAction(question)
      }
    },

    trackAIAction(question) {
      OpenAIApi.trackAIAction({
        objectId: this.slideActive?.id,
        objectType: ALLOWED_OBJECT_TYPE.SLIDE,
        actionType: ALLOWED_ACTION_TYPE.TITLE_RECOMMENDATION,
        actionDetail: {
          value: question,
        },
      })
    },
  },

}
</script>

<style scoped>
.wrapper{
  display: flex;
  gap: 4px;
  padding: 7px 0px 10px 0px;
  flex-direction: column;
  justify-content: center;
}
.wrapper-loading{
  display: flex;
  gap: 8px;
  padding: 10px 0px 8px 0px;
}
.center-box{
  display: flex;
  align-items: flex-start;
}
.box-svg{
 width:  14px;
}
.slide-question-suggestions {
  margin: 20px;
}

</style>
